import { render, staticRenderFns } from "./UsuariosPage.html?vue&type=template&id=66de4e55&external"
import script from "./UsuariosPage.vue?vue&type=script&lang=ts"
export * from "./UsuariosPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports